import { GradientButton } from '@/components/common';
import { useNavigate } from 'react-router-dom';

export default function ContactSection() {
	const navigate = useNavigate();

	const handleContactClick = () => {
		navigate('/contact-us');
	};

	return (
		<section
			className="relative text-white overflow-hidden mt-14"
			style={{ background: '#000000e0' }}
		>
			{/* Deep base layer */}
			<div className="absolute inset-0" style={{ background: '#000000e0' }}></div>

			{/* Radial mesh gradients */}
			<div
				className="absolute inset-0"
				style={{
					background: `
						radial-gradient(ellipse 80% 60% at 70% 20%, rgba(59,130,246,0.18) 0%, transparent 60%),
						radial-gradient(ellipse 60% 50% at 15% 75%, rgba(139,92,246,0.15) 0%, transparent 55%),
						radial-gradient(ellipse 40% 40% at 90% 80%, rgba(99,102,241,0.10) 0%, transparent 50%)
					`
				}}
			></div>

			{/* Subtle grid pattern */}
			<div
				className="absolute inset-0 opacity-[0.04]"
				style={{
					backgroundImage: `
						linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px),
						linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)
					`,
					backgroundSize: '60px 60px'
				}}
			></div>

			{/* Glowing orbs */}
			<div className="absolute inset-0 overflow-hidden">
				<div
					className="absolute animate-pulse"
					style={{
						top: '10%', right: '10%',
						width: '380px', height: '380px',
						background: 'radial-gradient(circle, rgba(59,130,246,0.22) 0%, transparent 70%)',
						filter: 'blur(40px)',
						animationDuration: '4s'
					}}
				></div>
				<div
					className="absolute animate-pulse"
					style={{
						bottom: '10%', left: '5%',
						width: '440px', height: '440px',
						background: 'radial-gradient(circle, rgba(139,92,246,0.18) 0%, transparent 70%)',
						filter: 'blur(50px)',
						animationDuration: '6s',
						animationDelay: '1s'
					}}
				></div>
				<div
					className="absolute animate-pulse"
					style={{
						top: '50%', left: '50%',
						transform: 'translate(-50%, -50%)',
						width: '300px', height: '300px',
						background: 'radial-gradient(circle, rgba(99,102,241,0.10) 0%, transparent 70%)',
						filter: 'blur(60px)',
						animationDuration: '8s',
						animationDelay: '2s'
					}}
				></div>
			</div>

			{/* Diagonal light streak */}
			<div
				className="absolute inset-0 opacity-[0.03]"
				style={{
					background: 'linear-gradient(135deg, transparent 30%, rgba(255,255,255,0.6) 50%, transparent 70%)',
					backgroundSize: '200% 200%'
				}}
			></div>

			{/* Contact Form Section */}
			<div className="relative z-10 py-16 md:py-28">
				<div className="container">
					<div className="gap-16 text-center">
						<div className='max-w-4xl mx-auto'>
							<div className="inline-block mb-6">
								<span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
									Our Expertise
								</span>
							</div>

							<h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
								Discover Our{" "}
								<span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
									Expertise
								</span>
							</h2>

							<div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 mb-8">
								<p className="text-gray-200 lg:text-[18px] leading-relaxed mb-4">
									Why Choose Us At SAN micron, we bring deep expertise and a wealth of experience in IT solutions tailored to meet the unique needs of your business.
								</p>
								<p className="text-gray-200 lg:text-[18px] leading-relaxed">
									Our team is skilled in a wide range of technologies, enabling us to provide innovative, efficient, and scalable solutions that drive success.
								</p>
							</div>

							<div className="mt-12">
								<GradientButton onClick={handleContactClick}>
									Contact Us
								</GradientButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}